import EmployeeApi from '~/common/api/zeiterfassungServerApi/EmployeeApi';
import ProjectApi from '~/common/api/zeiterfassungServerApi/ProjectApi';
import { Employee } from '~/common/entities/Department/DepartmentTypes';
import { Flex, Select, Text, Button } from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import React, { createRef } from 'react';
import _ from 'lodash';

type FilterState = {
  type?: number;
  project?: number;
  employee?: string;
};

type ChangeRequestFiltersProps = {
  filterState: FilterState;
  setFilterState: React.Dispatch<React.SetStateAction<FilterState>>;
};

export const ChangeRequestFilters: React.FC<ChangeRequestFiltersProps> = ({
  filterState,
  setFilterState,
}) => {
  const t = useTranslate();
  const employeeRef = createRef<HTMLSelectElement>();
  const projectRef = createRef<HTMLSelectElement>();
  const typeRef = createRef<HTMLSelectElement>();

  const [{ data: employees }] = EmployeeApi.hooks.useEmployeeQuery();
  const [{ data: projects }] = ProjectApi.hooks.useProjectsQuery();

  const handleClick = () => {
    setFilterState((prev) => {
      const newFilter = { ...prev };
      if (employeeRef.current) {
        newFilter.employee =
          employeeRef.current.value !== '-1'
            ? employeeRef.current.value
            : undefined;
      }
      if (projectRef.current) {
        newFilter.project =
          projectRef.current.value !== '-1'
            ? parseInt(projectRef.current.value)
            : undefined;
      }
      if (typeRef.current) {
        console.log('typeref: ', typeRef.current);
        newFilter.type =
          typeRef.current.value !== '-1'
            ? parseInt(typeRef.current.value)
            : undefined;
      }
      return newFilter;
    });
  };

  const handleResetFilters = () => {
    setFilterState({});
    if (employeeRef.current) employeeRef.current.value = '-1';
    if (projectRef.current) projectRef.current.value = '-1';
    if (typeRef.current) typeRef.current.value = '-1';
  };
  const isAnyFilterApplied =
    (filterState.project !== undefined && filterState.project !== -1) ||
    (filterState.employee !== undefined && filterState.employee !== '-1') ||
    (filterState.type !== undefined && filterState.type !== -1);
  return (
    <Flex direction="row" justify="space-between" mb={3}>
      <Flex gap={3}>
        <Select ref={employeeRef} style={{ width: '145px' }}>
          <option value="-1">{t('selectEmployee')}</option>
          {_.orderBy(employees, [(e) => e.user.first_name], ['asc'])?.map(
            (e: Employee) => (
              <option key={e.id} value={e.id}>
                {e.user.first_name + ' ' + e.user.last_name}
              </option>
            ),
          )}
        </Select>
        <Select ref={projectRef} style={{ width: '145px' }}>
          <option value="-1">{t('selectProject')}</option>
          {_.orderBy(projects, ['name'], ['asc'])?.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </Select>
        <Select
          ref={typeRef}
          style={{
            width: 'fit-content',
            minWidth: '145px',
            paddingRight: '28px',
          }}
        >
          <option value="-1">{t('changeRequest.type')}</option>
          {['0', '1', '2', '3', '4'].map((type) => (
            <option key={type} value={type}>
              {t(`changeRequest.type.${type}`)}
            </option>
          ))}
        </Select>
        <Flex gap={3} alignItems="center">
          {isAnyFilterApplied && (
            <Text
              textDecoration="underline"
              cursor="pointer"
              color="green.600"
              style={{ whiteSpace: 'nowrap' }}
              onClick={handleResetFilters}
            >
              {t('resetFilter')}
            </Text>
          )}
          <Button onClick={handleClick}>{t('search')}</Button>
        </Flex>
      </Flex>
    </Flex>
  );
};
